import React, { useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

export const PasswordField = ({ error, label, disabled, value, onChange }) => {
    const [visible, setVisible] = useState(false);
    return (
        <TextField
            type={visible ? 'text' : 'password'}
            fullWidth
            error={!!error}
            margin="normal"
            variant="outlined"
            label={label}
            onChange={event => onChange(event.target.value, event)}
            helperText={error}
            value={value}
            disabled={disabled}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            edge="end"
                            aria-label="toggle password visibility"
                            onClick={() => setVisible(!visible)}
                        >
                            {visible ? (
                                <VisibilityOff color="primary" />
                            ) : (
                                <Visibility color="primary" />
                            )}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
};
